import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronRightIcon, SparklesIcon } from 'lucide-react';
import { ProgressBar } from '../components/ProgressBar';
import { ObjectivesList } from '../components/ObjectivesList';
import { useDriver } from '../context/DriverContext';
const TOTAL_BADGES = 20; // Total number of badges available in the system
export function TombolaPage() {
  const navigate = useNavigate();
  const {
    driverData
  } = useDriver();
  if (!driverData) {
    navigate('/login');
    return null;
  }
  const ridesToNext = driverData.nextLevelRides - driverData.rides;
  const unlockedBadges = driverData.badges.filter(b => b.unlocked);
  const currentBadge = [...unlockedBadges].sort((a, b) => (b.unlockedAt?.getTime() || 0) - (a.unlockedAt?.getTime() || 0))[0];
  return <div className="min-h-screen bg-gray-50 pb-20" data-id="element-257">
      <div className="max-w-lg mx-auto" data-id="element-258">
        <header className="px-4 pt-6 pb-6 relative overflow-hidden" style={{
        backgroundImage: 'url(https://tombola.albarakah.ci/images/tombola-bg.jpg)',
        backgroundSize: 'cover',
        backgroundPosition: 'center top',
        minHeight: '180px'
      }} data-id="element-259">
          <div className="relative z-10" data-id="element-260">
            <h1 className="text-white text-2xl font-bold drop-shadow-lg" data-id="element-261">
              Bonjour {driverData.name} 👋
            </h1>
          </div>
        </header>
        <div className="px-4 -mt-8 relative z-20 space-y-4" data-id="element-262">
          <div className="bg-white rounded-2xl shadow-lg border border-gray-100 overflow-hidden" data-id="element-263">
            <div className="px-6 pt-6 pb-4 border-b border-gray-100" data-id="element-264">
              <div className="flex items-end justify-between" data-id="element-265">
                <div data-id="element-266">
                  <p className="text-sm text-gray-500 mb-1" data-id="element-267">Vos tickets</p>
                  <p className="text-4xl font-bold text-gray-900" data-id="element-268">
                    {driverData.tickets}
                  </p>
                </div>
                <div className="text-right" data-id="element-269">
                  <p className="text-xs text-gray-400 mb-1" data-id="element-270">Courses</p>
                  <p className="text-lg font-semibold text-gray-600" data-id="element-271">
                    {driverData.rides}
                  </p>
                </div>
              </div>
            </div>
            <div className="px-6 py-5 bg-gradient-to-br from-gray-50 to-white" data-id="element-272">
              <ProgressBar current={driverData.rides} target={driverData.nextLevelRides} data-id="element-273" />
              <p className="text-sm text-gray-600 mt-3" data-id="element-274">
                Encore{' '}
                <span className="font-semibold text-gray-900" data-id="element-275">
                  {ridesToNext} courses
                </span>{' '}
                pour le niveau suivant
              </p>
            </div>
          </div>
          {currentBadge && <button onClick={() => navigate('/badges')} className="w-full bg-gradient-to-br from-amber-50 to-orange-50 rounded-2xl p-5 shadow-sm border border-amber-100 hover:shadow-md transition-all duration-200" data-id="element-276">
              <div className="flex items-center justify-between mb-3" data-id="element-277">
                <div className="flex items-center gap-2" data-id="element-278">
                  <SparklesIcon className="w-4 h-4 text-amber-600" data-id="element-279" />
                  <span className="text-sm font-medium text-amber-900" data-id="element-280">
                    Badge actuel
                  </span>
                </div>
                <div className="flex items-center gap-2" data-id="element-281">
                  <span className="text-xs text-amber-700" data-id="element-282">
                    {unlockedBadges.length}/{TOTAL_BADGES}
                  </span>
                  <ChevronRightIcon className="w-4 h-4 text-amber-600" data-id="element-283" />
                </div>
              </div>
              <div className="flex items-center gap-4" data-id="element-284">
                <div className="w-16 h-16 bg-white rounded-2xl flex items-center justify-center text-4xl shadow-sm flex-shrink-0" data-id="element-285">
                  {currentBadge.icon}
                </div>
                <div className="flex-1 text-left" data-id="element-286">
                  <h3 className="font-bold text-gray-900 mb-1" data-id="element-287">
                    {currentBadge.name}
                  </h3>
                  <p className="text-sm text-gray-600" data-id="element-288">
                    {currentBadge.description}
                  </p>
                </div>
              </div>
            </button>}
        </div>
        <div className="px-4 py-6 space-y-6" data-id="element-289">
          <section data-id="element-290">
            <h2 className="text-lg font-bold text-gray-900 mb-4" data-id="element-291">Objectifs</h2>
            <ObjectivesList objectives={driverData.objectives} data-id="element-292" />
          </section>
        </div>
      </div>
    </div>;
}